module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/2-54e9a7349efce7f75ab6dbf358a40d0f.png";